<template>
	<base-nav
		container-classes="container-fluid"
		class="navbar-top border-bottom navbar-expand"
		id="navTop"
		:class="[{'standard-bg navbar-dark': type === 'default'}]"
	>
		<!--Top Navigation-->
		<img v-bind:src="pageLogo"  class="page-nav-logo" alt="Sidebar logo" />
		<b-nav pills class="top-nav-style custom-nav-style " v-if="!$sidebar.showSidebar">
			<div v-for="(items, index) in navTopBar" v-bind:key="index">
				<b-nav-item class="d-block-custom" v-if="!items.child" :to="items.path"
					><i class="fa mr-2" :class="items.icon" font-scale="1"></i>{{ items.name }}
				</b-nav-item>
				<b-nav-item-dropdown
					id="my-nav-dropdown "
					:text="items.name"
					v-if="items.child"
					toggle-class="nav-link-custom"
				>
					<template slot="button-content">
						<i class="fa mr-2" :class="items.icon" font-scale="1"></i
						><span>{{ items.name }}</span></template
					>
					<b-dropdown-item v-for="(children, index) in items.child" v-bind:key="index" :to="children.path">
						<i class="fa" :class="children.icon" font-scale="1"></i>{{ children.name }}
					</b-dropdown-item>
				</b-nav-item-dropdown>
			</div>
		</b-nav>
		
		<!-- Navbar links -->
		<b-navbar-nav class="align-items-center ml-md-auto  ml-xs-left">
			<!-- This item dont have <b-nav-item> because they add class 'nav-link' which is not needed here -->
			<li class="nav-item d-xl-none">
				<!-- Sidenav toggler -->
				<div
					class="pr-3 sidenav-toggler"
					:class="{
						active: $sidebar.showSidebar,
						'sidenav-toggler-dark': type === 'default',
						'sidenav-toggler-light': type === 'light',
					}"
					@click="toggleSidebar"
				>
					<div class="sidenav-toggler-inner">
						<i class="sidenav-toggler-line"></i>
						<i class="sidenav-toggler-line"></i>
						<i class="sidenav-toggler-line"></i>
					</div>
					
				</div>
			</li>
			
			<!-- Activity Log -->
			<base-dropdown
				class="nav-item notification-display"
				tag="li"
				title-classes="nav-link"
				title-tag="a"
				icon="ni ni-bell-55"
				menu-classes="dropdown-menu-xl dropdown-menu-right py-0 overflow-hidden"
			>
				<template>
					<!-- List group -->
					<b-list-group flush>
						<TransactionHistory></TransactionHistory>
					</b-list-group>
					<!-- View all -->
					<!-- This item dont have <b-dropdown-item> because item have styles " text-center text-primary font-weight-bold py-3" on tag <a> wich we cant add -->
				</template>
			</base-dropdown>
		</b-navbar-nav>
		<!-- User Menu -->
		<b-navbar-nav class="align-items-center ml-auto ml-md-0">
			<base-dropdown
				menu-on-right
				class="nav-item"
				tag="li"
				title-tag="a"
				:userName="userName"
				title-classes="nav-link pr-0"
			>
				<a href="#" class="nav-link header-user pr-0" @click.prevent slot="title-container">
					<b-media no-body class="align-items-center">
						<span class="avatar avatar-sm rounded-circle">
							<img :alt="userName" src="/img/theme/profile-avatar2.jpg" v-if="!uploadAvatarStatus" />
							<img :src="avatarSrc" :alt="userName" v-if="uploadAvatarStatus" />
						</span>
						<b-media-body class="ml-2 d-lg-block custom-name-style">
							<span class="mb-0 text-sm font-weight-bold" v-if="name">{{ name }} </span>
						</b-media-body>
					</b-media>
				</a>
				<b-dropdown-item class="custom-username-style">
					<i class="ni ni-single-02"></i>
					<span>{{name}}</span>
				</b-dropdown-item>

				<div class="dropdown-divider custom-username-style"></div>
				
				<b-dropdown-item to="/activity">
					<i class="ni ni-calendar-grid-58"></i>
					<span>Activity</span>
				</b-dropdown-item>

				<b-dropdown-item to="/support">
					<i class="ni ni-support-16"></i>
					<span>Support</span>
				</b-dropdown-item>

				<b-dropdown-item to="/serverstatus" v-if="isPortalAdminStatus">
					<i class="ni ni-support-16"></i>
					<span>Server Status</span>
				</b-dropdown-item>

<!--				<b-dropdown-item to="/portal-settings" v-if="isPortalAdminStatus">-->
<!--					<i class="ni ni-settings"></i>-->
<!--					<span>Portal Settings</span>-->
<!--				</b-dropdown-item>-->

				<div class="dropdown-divider"></div>

				<b-dropdown-item v-on:click="onLogOut()">
					<i class="ni ni-user-run"></i>
					<span>Logout</span>
				</b-dropdown-item>
			</base-dropdown>
		</b-navbar-nav>
	</base-nav>
</template>
<script>
import {CollapseTransition} from "vue2-transitions";
import {BaseNav, Modal} from "@/components";
import {LOGOUT} from "../../store/auth.module";
import AuthService from "../../common/api-services/auth-service";
import initService from "../../common/api-services/init-service";
import TransactionHistory from "../Pages/UserProfile/Transaction-History";
import VueCoreImageUpload from "vue-core-image-upload";

export default {
	components: {
		CollapseTransition,
		BaseNav,
		Modal,
		VueCoreImageUpload,
		TransactionHistory,
	},
	props: {
		type: {
			type: String,
			default: "default", // default|light
			description: "Look of the dashboard navbar. Default (Green) or light (gray)",
		},
	},
	computed: {
		routeName() {
			const {name} = this.$route;
			return this.capitalizeFirstLetter(name);
		},
	},
	data() {
		return {
			activeNotifications: false,
			showMenu: false,
			searchModalVisible: false,
			searchQuery: "",
			topNav: [],
			userName: "",
			navTopBar: [],
			isAdminStatus: false,
			hasImage: false,
			uploadAvatarStatus: false,
			avatarSrc: "",
			name: "",
			getUserGroupInfo: null,
			isPortalAdminStatus: false,
			isReadonyStatus: false,
			pageLogo: process.env.VUE_APP_PORTAL_LOGO,
		};
	},
	mounted() {

		this.name = initService.getNameInfo();
		this.userName = initService.getUserNameInfo();
		this.getUserGroupInfo = initService.getGroupInfo();
		this.isPortalAdminStatus = initService.getPortalAdminRole();
		this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
		const groups = initService.getGroups();

		this.$root.$on("uploadImage", imageSrc => {
			this.uploadAvatarStatus = true;
			this.avatarSrc = imageSrc;
		});
	},
	methods: {
		// getTopNavigationFunc() {
		//   this.topNav = configDirective.getTopNavigation();
		// },

		capitalizeFirstLetter(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		},
		toggleNotificationDropDown() {
			this.activeNotifications = !this.activeNotifications;
		},
		closeDropDown() {
			this.activeNotifications = false;
		},
		toggleSidebar() {
			this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
		},
		hideSidebar() {
			this.$sidebar.displaySidebar(false);
		},
		async onLogOut() {
			try {
				initService.clearCache();
				await AuthService.logoutService();
				await this.$store.dispatch(LOGOUT);
			} catch (error) {
				console.error(error);
			} finally {
				this.$router.push({name: "login"});
			}
		},
		showTopNav() {
			this.$sidebar.showSidebar = !this.$sidebar.showSidebar;
		},
	},
};
</script>
<style>
[v-clock] {
	display: none !important;
}
</style>
